import { AvatarSizeTokens, } from '@voltmoney/schema';
export const avatarTypeTokensMap = {
    [AvatarSizeTokens.XS]: 20,
    [AvatarSizeTokens.SM]: 24,
    [AvatarSizeTokens.MD]: 32,
    [AvatarSizeTokens.LG]: 40,
    [AvatarSizeTokens.XL]: 48,
    [AvatarSizeTokens.XXL]: 80,
    [AvatarSizeTokens.XXXL]: 100,
};
